import { ChatMessagePart } from "../components/ChatMessagePart";
import { Table, TableDisplayData } from "../components/Table";
import { isTable } from "../utils/guards";
import { MessageMiddlewareBuilder, MessageMiddlewareFC } from "./message-middleware";

const TableMiddlewareWidget: MessageMiddlewareFC<TableDisplayData> = (props) => {
    const { msg, ctx } = props;

    if (!ctx) {
        throw new TypeError(`ctx not provided to ${TableMiddlewareWidget.name}`);
    }

    return (
        <ChatMessagePart showAvatar={false} user={ctx.user} fullWidth>
            <div className="chat-msg chat-msg--expand">
                <Table table={msg} />
            </div>
        </ChatMessagePart>
    );
};

export const TableMiddleware: MessageMiddlewareBuilder = (next) => (props) => {
    const { msg, ctx } = props;

    if (isTable(msg)) {
        return <TableMiddlewareWidget msg={msg} ctx={ctx} />;
    }

    return next(props);
};
